import { CategoryTag } from '@/model/response';
import { extractFilterData } from '@/mapper/namespace/ExtractFilterData';
import { mergeTags } from '@/mapper/namespace/MergeTags';
import { Identifiable } from '@/model/Identifiable';

export const initFilterOptions = (categories: CategoryTag[]): Identifiable[] =>
  mergeTags(categories.map(extractFilterData), []);
